import { defineComponent as n, openBlock as r, createBlock as p, unref as l, mergeProps as v, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const h = /* @__PURE__ */ n({
  name: "IconCopy",
  __name: "IconCopy",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (r(), p(l(d), v(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "M11.5 3.25A2.25 2.25 0 0 0 9.25 5.5V6a.75.75 0 0 0 1.5 0V5.5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H16a.75.75 0 0 0 0 1.5h1.5a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-6" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M6.5 7.25A2.25 2.25 0 0 0 4.25 9.5v9a2.25 2.25 0 0 0 2.25 2.25h6a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-6M5.75 9.5A.75.75 0 0 1 6.5 8.75h6a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-9",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
